import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../../utils/apiConfig';

/**
 * LeaveStats - Widget "CP/RTT posés ce mois" pour RH
 */
const LeaveStats = ({ token, onNavigate }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      if (!token) return;

      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/dashboard/leave-stats`,
          {
            headers: { 'Authorization': `Bearer ${token}` }
          }
        );

        if (!response.ok) throw new Error('Erreur de chargement');

        const result = await response.json();
        setData(result.success ? result.data : null);
      } catch (err) {
        console.error('Erreur fetch leave stats:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [token]);

  const getMonthName = () => {
    const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
                    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    return months[new Date().getMonth()];
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <h4 style={styles.title}>CP/RTT ce mois</h4>
        <div style={styles.loading}>Chargement...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <h4 style={styles.title}>CP/RTT ce mois</h4>
        <div style={styles.error}>{error}</div>
      </div>
    );
  }

  const stats = data?.stats || [];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h4 style={styles.title}>CP/RTT posés en {getMonthName()}</h4>
        <button
          style={styles.viewButton}
          onClick={() => onNavigate && onNavigate('hr')}
        >
          Voir vue RH
        </button>
      </div>

      {stats.length === 0 ? (
        <div style={styles.empty}>
          <span style={styles.emptyIcon}>📊</span>
          <p style={styles.emptyText}>Aucun congé posé ce mois</p>
        </div>
      ) : (
        <div style={styles.statsGrid}>
          {stats.map((stat, index) => (
            <div key={stat.code || index} style={styles.statCard}>
              <div
                style={{
                  ...styles.statBadge,
                  backgroundColor: stat.color || '#6c757d'
                }}
              >
                {stat.code}
              </div>
              <div style={styles.statValue}>{stat.days_count} j</div>
              <div style={styles.statLabel}>
                {stat.users_count} pers.
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  title: {
    margin: 0,
    fontSize: '1.1rem',
    fontWeight: '600',
    color: '#1a1a2e'
  },
  viewButton: {
    background: 'none',
    border: 'none',
    color: '#6366f1',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '500'
  },
  loading: {
    textAlign: 'center',
    padding: '30px',
    color: '#6c757d'
  },
  error: {
    padding: '20px',
    backgroundColor: '#fff5f5',
    borderRadius: '8px',
    color: '#dc3545',
    textAlign: 'center'
  },
  empty: {
    textAlign: 'center',
    padding: '30px'
  },
  emptyIcon: {
    fontSize: '2rem',
    display: 'block',
    marginBottom: '8px'
  },
  emptyText: {
    margin: 0,
    color: '#6c757d'
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
    gap: '12px'
  },
  statCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '10px'
  },
  statBadge: {
    padding: '4px 12px',
    borderRadius: '6px',
    fontSize: '0.85rem',
    fontWeight: '600',
    color: 'white',
    marginBottom: '8px'
  },
  statValue: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e'
  },
  statLabel: {
    fontSize: '0.8rem',
    color: '#6c757d',
    marginTop: '4px'
  }
};

export default LeaveStats;
